var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/lodash/_hashClear.js
// module id = 300
// module chunks = 3 4 5 6 7 8 9